import { Input, InputProps } from '@chakra-ui/react'

type Props = InputProps & { isError: boolean; isSmaller: boolean }

const StyledSearchInput = ({ isError, isSmaller, ...inputProps }: Props): JSX.Element => {
  return (
    <Input
      borderRadius="small"
      fontSize="sm"
      backgroundColor="green.a175"
      width="100%"
      color={isError ? 'red.a150' : 'black'}
      border={isError ? '1px solid {colors.red.a100}' : 'none'}
      height={isSmaller ? '36px' : '54px'}
      _placeholder={{
        color: isError ? 'red.a150' : 'green.a200',
      }}
      css={{
        // This is to prevent zoom in on iOS. According to this SO thread https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone/6394497
        // if font size in input is smaller than 16px, iOS will zoom in and therefore break layout. Using this bit of code we can detect iPhone and set there font size equal to 16px.
        '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
          fontSize: '16px',
        },
      }}
      _focus={{
        outline: 'none',
        boxShadow: 'none',
        border: 'none',
      }}
      _disabled={{
        opacity: 0.5,
        pointerEvents: 'none',
      }}
      {...inputProps}
    />
  )
}

export default StyledSearchInput
